
	import _ from "lodash";
	export default {
		name: "view-messages",
		props: {
			messages: Array,
			overlay: {
				type: Boolean,
				default: false
			},
			defaultTimeout: {
				type: Number,
				default: 2000
			}
		},
		data() {
			return {
				timers: {}
			};
		},
		methods: {
			syncTimers() {
				_.forEach(this.messages, msg => {
					if (!this.timers[msg.name]) {
						const timeout = _.isNumber(msg.timeout)
							? msg.timeout
							: this.defaultTimeout;

						if (timeout > 0) {
							this.timers[msg.name] = setTimeout(() => {
								this.close(msg.name);
							}, timeout);
						}
					}
				});
			},
			close(name) {
				this.clearTimer(name);
				this.$emit('close', name);
			},
			clearTimer(name) {
				if (this.timers[name]) {
					clearTimeout(this.timers[name]);
					delete this.timers[name];
				}
			}
		},
		mounted() {
			this.syncTimers();
		},

		updated() {
			this.syncTimers();
		},

		beforeDestroy() {
			Object.values(this.timers).forEach(clearTimeout);
			this.timers = {};
		},
	}
